module.exports = __webpack_public_path__ + "img/决明子.cf380693.jpg";